import { WESER_EMS_MARKETING_URL } from "core/consts";
import { AppBar, LeftPart, LogoWrapper } from "ds_legacy/components/AppBar";
import { RecareNameLogo } from "ds_legacy/components/RecareLogo";
import { SMALL, dp } from "ds_legacy/materials/metrics";
import Image from "dsl/atoms/Image";
import { useB2CNavigationUrls } from "dsl/hooks/useNavigationHandlers";
import { B2CFilters } from "dsl/organisms/Filters/B2CApp/types";
import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslations } from "translations";

const WeserEmsLogoWrapper = ({
  children,
  filters,
}: {
  children: React.ReactElement<any>[];
  filters: B2CFilters;
}) => {
  const location = useLocation();
  const { goToDashboard } = useB2CNavigationUrls();
  const shouldLinkToMarketingWebsite =
    !!location.pathname.includes("onboarding");

  return shouldLinkToMarketingWebsite ? (
    <LogoWrapper href={WESER_EMS_MARKETING_URL} target="_blank">
      {children}
    </LogoWrapper>
  ) : (
    <LogoWrapper to={goToDashboard({ filters })}> {children} </LogoWrapper>
  );
};

export default function Header({ filters }: { filters: B2CFilters }) {
  const translations = useTranslations();

  return (
    <AppBar>
      <LeftPart>
        <WeserEmsLogoWrapper filters={filters}>
          <Image
            alt="gewinet-logo"
            path="Gewinet_Logo.png"
            style={{ height: dp(30), width: dp(34) }}
          />
          <h2 className="mx-4 my-2 text-xs font-normal leading-7 text-white tablet:text-base">
            {translations.bToC.navbar.title}
          </h2>
        </WeserEmsLogoWrapper>
      </LeftPart>
      <div className="mr-3 h-6 w-px self-center bg-white opacity-50" />
      <RecareNameLogo size={SMALL} style={{ alignSelf: "center" }} />
    </AppBar>
  );
}
